import { render, staticRenderFns } from "./group_registration.vue?vue&type=template&id=df014dde&scoped=true&"
import script from "./group_registration.vue?vue&type=script&lang=ts&"
export * from "./group_registration.vue?vue&type=script&lang=ts&"
import style0 from "./group_registration.vue?vue&type=style&index=0&id=df014dde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df014dde",
  null
  
)

export default component.exports